/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable arrow-body-style */
import React, { useState, useEffect, useCallback, SetStateAction, ChangeEvent, ReactNode } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { v4 as uuidv4 } from 'uuid';
import {
  Assignment,
  AssignmentTurnedIn,
  CheckBox,
  Clear,
  Phone,
  PhoneCallback,
  PhoneInTalk,
  Search,
  Star,
} from '@material-ui/icons';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { Box, Checkbox, Fade, FormControlLabel, Grid, Modal, Radio, RadioGroup, TextField } from '@material-ui/core';
import { _ } from 'ag-grid-community';
import { CallEvent } from '../QueueLeaderboard';

const colorGetter = (state: string, mode: string) => {
  if (state === 'RINGING' || state === 'TALKING') {
    return mode === 'light' ? 'black' : 'white';
  }
  return mode === 'light' ? '#888' : '#aaa';
};

function regexCheck(str: string, number: string): boolean {
  const escapeRegex = (s: string): string => s.replace(/([.+^=!:${}()|\\])/g, '\\$1');

  const temp = '^'.concat(number.split('*').map(escapeRegex).join('.*'), '$');
  const r = new RegExp(temp.split('?').join('.'));

  return r.test(str);
}

const sanitizeNotes = (note: string): string => {
  return note.replace(/<script\b[^>]*>(.*?)<\/script>/gi, '');
};

interface VipItem {
  PartitionKey: string;
  SortKey: string;
  name: string;
  number: string;
}

export interface CodeItem {
  PartitionKey: string;
  SortKey: string;
  code: string;
  id: string;
}

export interface CodeTable {
  PartitionKey: string;
  SortKey: string;
  id: string;
  name: string;
  type: string;
  items: CodeItem[];
}

interface CodeDetail {
  code: string;
  codeDescription: string;
  codeNumber: string;
  time: string;
}

interface CxCall {
  extensionId: string;
  extension: string;
  state: string;
  timestamp: string;
  callId: string;
  queues: string[];
  agentDisposition?: string;
  ani: string;
  dnis: string;
  callStart: string;
  callType: string;
  direction: string;
  agentCount: number;
  duration: number;
  count: number;
  queueDuration: number;
  agentWrapTime: number;
  agentWrapCount: number;
  ringTime: number;
  ringCount: number;
}

export interface DispositionEvent {
  id: string; // CallId,
  userId: string; // Owner of call
  direction: string; // Direction, can be Internal
  date: string; // ISOString for date
  duration: number; // number in milliseconds
  state: string; // Call state
  fromNumber: string;
  toNumber: string;
  fromName: string;
  toName: string;
  internal: boolean;
  codeInfo?: CodeDetail;
  forcedInfo?: CodeDetail;
  accountInfo?: CodeDetail;
  rating?: number;
}

export interface CxDispositionEvent {
  timestamp: string;
  direction: string;
  ani: string;
  duration: number;
  extensionId: string;
  state: string;
  agentDisposition?: string;
  callId: string;
}

const DurationRenderer = ({ state, time }: { state: string; time: number }) => {
  if (state === 'RINGING' || state === 'TALKING' || !state)
    return <div style={{ color: '#519e51' }}>{state.slice(0, 1).toUpperCase() + state.slice(1).toLowerCase()}</div>;
  const totalSeconds = Math.floor(time / 1000);
  const minutes = Math.floor((totalSeconds % 3600) / 60) || '00';
  const seconds = totalSeconds % 60 || '00';
  const duration = [minutes, seconds].map((unit) => String(unit).padStart(2, '0')).join(':');
  return <>{duration}</>;
};
const DirectionRenderer = ({ direction, mode }: { direction: string; mode: string }) => {
  if (direction === 'Inbound')
    return <PhoneCallback fontSize="small" style={{ color: mode === 'light' ? 'black' : 'white' }} />;
  if (direction === 'Outbound')
    return <PhoneInTalk fontSize="small" style={{ color: mode === 'light' ? 'black' : 'white' }} />;
  return <Phone fontSize="small" style={{ color: mode === 'light' ? 'black' : 'white' }} />;
};

const CXdurationRenderer = ({ time }: { time: number }) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(seconds).padStart(2, '0');
  return (
    <>
      {paddedMinutes}:{paddedSeconds}
    </>
  );
};

const CxCallRow = ({
  currentCall,
  callOnClick,
  event,
  vip,
  mode,
}: {
  mode: string;
  callOnClick: (phone: string) => void;
  currentCall: boolean;
  event: CxDispositionEvent;
  vip: VipItem | undefined;
}) => {
  const { direction, duration, timestamp, ani, state, agentDisposition, callId } = event;
  return (
    <div className={`disposition-call-row ${mode === 'light' ? 'disposition-light-mode' : 'disposition-dark-mode'}`}>
      <div className="disposition-call-row-left">
        <button
          disabled={currentCall}
          className={`disposition-dial-button ${currentCall && 'disabled'}`}
          type="button"
          onClick={() => callOnClick(ani)}
        >
          <div className="disposition-button-row">
            {direction === 'Inbound' && (
              <div
                className="disposition-button-content"
                style={{ color: currentCall ? colorGetter(state, mode) : mode === 'light' ? 'black' : 'white' }}
              >
                <div>
                  <DirectionRenderer direction={direction} mode={mode} />
                </div>
                <div className="content-right">
                  {!vip && <div className="content-right_header">{ani}</div>}
                  {vip && (
                    <div className={`content-right_header ${mode === 'light' ? 'light-vip' : 'dark-vip'}`}>
                      <Star fontSize="small" style={{ color: mode === 'light' ? '#c8b343' : '#ccae0e' }} />
                      {vip.name}
                    </div>
                  )}
                  <div className="content-right_subheader">{ani}</div>
                </div>
              </div>
            )}
            {direction !== 'Inbound' && (
              <div
                className="disposition-button-content"
                style={{ color: currentCall ? colorGetter(state, mode) : mode === 'light' ? 'black' : 'white' }}
              >
                <div>
                  <DirectionRenderer direction={direction} mode={mode} />
                </div>
                <div className="content-right">
                  {!vip && <div className="content-right_header">{ani}</div>}
                  {vip && (
                    <div className={`content-right_header ${mode === 'light' ? 'light-vip' : 'dark-vip'}`}>
                      <Star fontSize="small" style={{ color: mode === 'light' ? '#c8b343' : '#ccae0e' }} />
                      {vip.name}
                    </div>
                  )}
                  <div className="content-right_subheader">{ani}</div>
                </div>
              </div>
            )}
          </div>
        </button>
      </div>
      <div className="disposition-call-row-center">
        <div>
          {new Date(timestamp.replace(/Z$/, '')).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </div>
        <div>
          {' '}
          <CXdurationRenderer time={duration} />
        </div>
      </div>
      <div className="disposition-call-row-right" style={{ width: 300 }}>
        {agentDisposition && (
          <div className={`agent-disposition-display ${mode}`}>
            <div>{agentDisposition}</div>
            <span className={`submit-span ${mode}`}>
              Submitted: {new Date(timestamp.replace(/Z$/, '')).toLocaleString()}
            </span>
          </div>
        )}
        <span className={`cx-indicator ${mode}`}>CX</span>
      </div>
    </div>
  );
};

const ErrorGetter = ({ error, renderFor }: { error: string; renderFor: 'disposition' | 'account' }): JSX.Element => {
  if (error) {
    if (renderFor === 'disposition') {
      if (error === 'invalid-disposition') return <span>Disposition code was not recognized. Please try again.</span>;
      if (error === 'void-disposition') return <span>Please add a disposition code.</span>;
    }
    if (renderFor === 'account') {
      if (error === 'invalid-account-code') return <span>Invalid file number.</span>;
      if (error === 'void-account-code') return <span>Please add a file number.</span>;
    } else {
      return <span style={{ color: 'transparent' }}>.</span>;
    }
  }
  return <span style={{ color: 'transparent' }}>.</span>;
};

const MesserliKramerCallRow = ({
  currentCall,
  event,
  vip,
  callOnClick,
  codeTables,
  mode,
  codeMap,
  // setSelectedCall,
  codeTab,
  organizationId,
  rcId,
  idToken,
  setCodeMap,
}: {
  organizationId: string | undefined;
  rcId: string | undefined;
  hasCx: boolean;
  currentCall: boolean;
  idToken: string;
  codeMap: ImmutableMap<string, DispositionEvent>;
  setCodeMap: React.Dispatch<SetStateAction<ImmutableMap<string, DispositionEvent>>>;
  mode: string;
  vip: VipItem | undefined;
  event: DispositionEvent;
  // setSelectedCall: React.Dispatch<SetStateAction<any>>;
  callOnClick: (n: string) => void;
  codeTables: CodeTable[];
  setCode: (id: string, type: 'Disposition' | 'Account' | 'Forced', codeItem: CodeItem | undefined) => void;
  codeTab: 'Disposition' | 'Account' | 'Forced';
}) => {
  const {
    id,
    codeInfo, //
    accountInfo,
    userId,
    direction,
    date,
    duration,
    state,
    fromNumber,
    toNumber,
    internal,
    fromName,
    toName,
  } = event;
  const [error, setError] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [customDispositionForm, setCustomDispositionForm] = useState<
    | {
        callId?: string;
        dispositionCode?: CodeItem;
        accountCode?: string;
        notes?: string;
      }
    | undefined
  >({
    callId: '',
    notes: '',
  });
  // strictly for debugging purposes
  const [submittedDisposition, setSubmittedDisposition] = useState<any>();

  const handleNoteInput = useCallback(
    (notes: string): void => {
      setCustomDispositionForm((prev) => ({
        ...prev,
        notes,
      }));
    },
    [customDispositionForm, error],
  );

  // close the modal
  const handleModalClose = useCallback(() => {
    setCustomDispositionForm(undefined);
    setError(undefined);
  }, [customDispositionForm, error]);

  // initialize the custom disposition form with a callId
  const getCall = useCallback(
    (i: any) => {
      setCustomDispositionForm((prev) => ({
        callId: i,
        dispositionCode: codeInfo
          ? codeTables[0]?.items?.find(
              (codeItem) => codeItem.id.trim() === `${codeInfo.codeNumber}:${codeInfo.codeDescription}`,
            )
          : undefined,
      }));
    },
    [customDispositionForm, error],
  );

  // evaluate the text fields for both disposition and account codes, then set any errors present
  const errorHandling = useCallback(() => {
    if (customDispositionForm) {
      const { dispositionCode, accountCode } = customDispositionForm;
      if (!dispositionCode?.id) {
        return setError('void-disposition');
      }
      if (!accountCode) {
        return setError('void-account-code');
      }
      if (accountCode) {
        if ([...accountCode].length < 8 || [...accountCode].length > 11 || [...accountCode][2] !== '-') {
          return setError('invalid-account-code');
        }
      }
      return setError(undefined);
    }
    return setError(undefined);
  }, [customDispositionForm, error]);

  const handleDispositionBlur = useCallback(
    (e: any) => {
      const foundItem: CodeItem | undefined = codeTables[0].items?.find(
        (item) => item.id?.trim() === e.target?.value?.trim(),
      );
      if (e.target.value === undefined || e.target.value.length === 0) {
        setError('void-disposition');
      } else if (e?.target?.value !== undefined || e?.target?.value?.length > 0) {
        if (foundItem) {
          setCustomDispositionForm((prev: any) => ({
            ...prev,
            dispositionCode: foundItem,
          }));
        } else {
          setCustomDispositionForm((prev: any) => ({
            ...prev,
            dispositionCode: undefined,
          }));
          setError('invalid-disposition');
        }
      }
    },
    [customDispositionForm, error],
  );

  const handleDispositionChange = useCallback(
    (e: any) => {
      const foundItem: CodeItem | undefined = codeTables[0]?.items?.find(
        (item) => item?.id?.trim() === e.target?.value?.trim(),
      );
      if (e?.target?.value === undefined || e?.target?.value?.length === 0 || e?.target?.value === null) {
        setError('void-disposition');
        setCustomDispositionForm((prev) => ({
          ...prev,
          dispositionCode: undefined,
        }));
      } else if (e.target.value !== undefined || e?.target?.value?.length > 0) {
        if (foundItem) {
          setCustomDispositionForm((prev: any) => ({
            ...prev,
            dispositionCode: foundItem,
          }));
        } else {
          setCustomDispositionForm((prev: any) => ({
            ...prev,
            dispositionCode: undefined,
          }));
        }
      }
    },
    [customDispositionForm, error],
  );

  const handleCustomAccountCodes = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    let accCodeStripped = inputValue.replace(/[^\d-]/g, '');
    if (accCodeStripped.length > 10) {
      accCodeStripped = accCodeStripped.slice(0, 11);
    }
    if (accCodeStripped.length <= 2) {
      accCodeStripped = accCodeStripped.replaceAll('-', '');
    }
    if (accCodeStripped.length > 2) {
      // eslint-disable-next-line prefer-template
      accCodeStripped = `${accCodeStripped.slice(0, 2).replaceAll('-', '')}-${accCodeStripped
        .slice(2)
        .replaceAll('-', '')}`;
    }
    accCodeStripped = accCodeStripped.replace(/-{2,}/g, '-');
    setCustomDispositionForm((prev) => ({
      ...prev,
      accountCode: accCodeStripped,
    }));
  };

  const sendCustomDisposition = useCallback(
    async (type: 'Disposition' | 'Account' | 'Forced') => {
      setLoading(true);

      try {
        if (!customDispositionForm) {
          setError('void-disposition');
          return;
        }

        const { dispositionCode, accountCode, callId, notes } = customDispositionForm;

        console.log(customDispositionForm);

        if (!dispositionCode) {
          setError('void-disposition');
          return;
        }

        if (!accountCode) {
          setError('void-account-code');
          return;
        }

        if (accountCode) {
          if ([...accountCode].length < 8 || [...accountCode].length > 11 || [...accountCode][2] !== '-') {
            setError('invalid-account-code');
            return;
          }
        }

        const prefixMap = {
          Disposition: 'DPL',
          Account: 'APL',
          Forced: 'FPL',
        } as const;
        const prefix = prefixMap[type];
        const [codeNumber, codeDescription] = dispositionCode?.id?.split(':') || ['', ''];
        const codeCallId = callId?.replace('s-', '');
        const message = `${prefix}:${codeCallId}:${codeNumber}:${codeDescription}`;
        const uuid = uuidv4();

        const sendDisposition = await fetch(`${process.env.REACT_APP_API_URL}/disposition-codes`, {
          method: 'POST',
          body: JSON.stringify({
            prefix,
            codeCallId,
            codeNumber,
            codeDescription,
            accountId: organizationId,
            extensionId: rcId,
            telephonySessionId: id,
            time: new Date().toISOString(),
            code: type,
            message,
            id: uuid,
            address: `${process.env.REACT_APP_API_URL}/site/main-site`,
            /* the "custom" object below was used in an older version.
                I'm unsure how things look on the Azure side, I'll keep this here for you just in case. */
            custom: {
              recId: 'RSI',
              platform: 'EX',
              userId: rcId,
              duration,
              direction,
              dispositionCode,
              accountCode,
              notes: sanitizeNotes(notes || ''),
              version: new Date().toISOString(),
              toNumber,
              fromNumber,
            },
          }),
          headers: {
            Authorization: idToken || '',
            'Content-Type': 'application/json',
          },
        });

        if (sendDisposition.ok) {
          setCodeMap((oldCodeMap) => {
            if (type === 'Disposition') {
              return oldCodeMap.update(id, (existing = {} as DispositionEvent) => ({
                ...existing,
                codeInfo: {
                  code: type,
                  codeDescription,
                  codeNumber,
                  time: new Date().toISOString(),
                },
              }));
            }
            if (type === 'Account') {
              return oldCodeMap.update(id, (existing = {} as DispositionEvent) => ({
                ...existing,
                accountInfo: {
                  code: type,
                  codeDescription,
                  codeNumber,
                  time: new Date().toISOString(),
                },
              }));
            }
            if (type === 'Forced') {
              return oldCodeMap.update(id, (existing = {} as DispositionEvent) => ({
                ...existing,
                forcedInfo: {
                  code: type,
                  codeDescription,
                  codeNumber,
                  time: new Date().toISOString(),
                },
              }));
            }
            return oldCodeMap;
          });
          setCustomDispositionForm(undefined);
        }
      } finally {
        setLoading(false);
      }
    },
    [rcId, idToken, codeTab, customDispositionForm],
  );

  return (
    <div className={`disposition-call-row ${mode === 'light' ? 'disposition-light-mode' : 'disposition-dark-mode'}`}>
      <div style={{ zIndex: 80000011 }}>
        <Modal
          disableBackdropClick={loading}
          disablePortal
          open={!!customDispositionForm?.callId}
          onClose={handleModalClose}
        >
          <Fade in={!!customDispositionForm?.callId}>
            <div
              style={{
                width: '50%',
                minWidth: 600,
                height: '50%',
                minHeight: 650,
                background: mode === 'light' ? 'white' : '#282828',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                position: 'absolute',
                boxShadow: `rgba(0, 0, 0, 0.2) 0px 3px 2px, rgba(0, 0, 0, 0.2) 0px -2px 16px, rgba(0, 0, 0, 0.2) 0px 0px 8px, rgba(0, 0, 0, 0.2) 0px 0px 16px, rgba(0, 0, 0, 0.2) -1px 0px 32px`,
              }}
            >
              {/* select disposition from list */}
              <div className={`custom-disposition-row ${mode}`}>
                <h3>Disposition Code</h3>
                <Autocomplete
                  id={id}
                  blurOnSelect
                  disabled={state === 'RINGING'}
                  disablePortal
                  className="custom-disposition-input"
                  defaultValue={
                    // codeInfo && codeInfo.codeNumber !== '' && codeInfo.codeDescription !== ''? `${codeInfo?.codeNumber}:${codeInfo?.codeDescription}`: null
                    customDispositionForm?.dispositionCode ? customDispositionForm?.dispositionCode?.id : undefined
                  }
                  options={codeTables[0]?.items?.map((code) => code.id)}
                  freeSolo
                  disableListWrap
                  filterOptions={createFilterOptions({ limit: 15 })}
                  value={customDispositionForm?.dispositionCode?.id}
                  // closeIcon={<Clear style={{zIndex: 900000000}} />}
                  onBlur={(e) => handleDispositionBlur(e)}
                  onFocus={() => setError(undefined)}
                  onChange={(e) => handleDispositionChange(e)}
                  ListboxProps={{
                    style: {
                      color: mode === 'light' ? 'black' : 'white',
                      background: mode === 'light' ? 'white' : '#444',
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      helperText={error && <ErrorGetter error={error} renderFor="disposition" />}
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{ color: 'orange' }}
                      fullWidth
                    />
                  )}
                />
              </div>
              {/* type in character-sensitive account code (numbers) */}
              <div className={`custom-disposition-row ${mode}`}>
                <h3>File Number</h3>
                <TextField
                  helperText={error && <ErrorGetter error={error} renderFor="account" />}
                  variant="outlined"
                  size="small"
                  fullWidth
                  placeholder="__-______"
                  value={customDispositionForm?.accountCode}
                  onFocus={() => setError(undefined)}
                  className={`disposition-v2-input ${mode === 'light' ? 'light' : 'dark'} ${
                    error ? 'custom-disposition-error' : ''
                  }`}
                  onChange={(e: React.ChangeEvent<any>) => handleCustomAccountCodes(e)}
                />
              </div>
              <div className={`custom-disposition-row ${mode}`}>
                <h3>Notes</h3>
                <textarea
                  className={`custom-disposition-notes ${mode}`}
                  placeholder="notes..."
                  onChange={(e) => handleNoteInput(e.target.value)}
                  rows={9}
                />
              </div>
              <div className="custom-disposition-row flex-row">
                <button
                  type="button"
                  disabled={loading}
                  className={`custom-disposition-button cancel-button ${mode}`}
                  onClick={() => {
                    setError(undefined);
                    setCustomDispositionForm(undefined);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  disabled={loading}
                  className={`custom-disposition-button submit-button ${mode}`}
                  onClick={() => {
                    errorHandling();
                    sendCustomDisposition('Disposition');
                  }}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
              {/* <table>
            {
              submittedDisposition && submittedDisposition.body && Object.entries(submittedDisposition.body).map(([key, value]) => (
                <tr>
                  <td>{key}</td>
                  <td>{value as any}</td>
                </tr>
              ))
            }
            </table> */}
            </div>
          </Fade>
        </Modal>
      </div>
      <div className="disposition-call-row-left">
        <button
          disabled={currentCall}
          className={`disposition-dial-button ${currentCall && 'disabled'}`}
          type="button"
          onClick={() => callOnClick(direction === 'Inbound' ? fromNumber : toNumber)}
        >
          <div className="disposition-button-row">
            {direction === 'Inbound' && (
              <div
                className="disposition-button-content"
                style={{ color: currentCall ? colorGetter(state, mode) : mode === 'light' ? 'black' : 'white' }}
              >
                <div>
                  <DirectionRenderer direction={direction} mode={mode} />
                </div>
                <div className="content-right">
                  {!vip && <div className="content-right_header">{fromName}</div>}
                  {vip && (
                    <div className={`content-right_header ${mode === 'light' ? 'light-vip' : 'dark-vip'}`}>
                      {' '}
                      <Star fontSize="small" style={{ color: mode === 'light' ? '#c8b343' : '#ccae0e' }} /> {vip.name}{' '}
                    </div>
                  )}
                  <div className="content-right_subheader">{fromNumber}</div>
                </div>
              </div>
            )}
            {direction !== 'Inbound' && (
              <div
                className="disposition-button-content"
                style={{ color: currentCall ? colorGetter(state, mode) : mode === 'light' ? 'black' : 'white' }}
              >
                <div>
                  <DirectionRenderer direction={direction} mode={mode} />
                </div>
                <div className="content-right">
                  {!vip && <div className="content-right_header">{toName}</div>}
                  {vip && (
                    <div className={`content-right_header ${mode === 'light' ? 'light-vip' : 'dark-vip'}`}>
                      <Star fontSize="small" style={{ color: mode === 'light' ? '#c8b343' : '#ccae0e' }} />
                      {vip.name}
                    </div>
                  )}
                  <div className="content-right_subheader">{toNumber}</div>
                </div>
              </div>
            )}
          </div>
        </button>
      </div>
      <div className="disposition-call-row-center">
        <div>
          {new Date(date).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </div>
        <div>
          <DurationRenderer state={state} time={duration} />
        </div>
      </div>
      <div className="disposition-call-row-right" style={{ justifyContent: 'center', alignItems: 'end' }}>
        <button className="custom-disposition-submission-button" type="button" onClick={() => getCall(id)}>
          {codeInfo?.time ? (
            <AssignmentTurnedIn fontSize="medium" style={{ color: mode === 'light' ? '#0485bf' : '#b5b5b5' }} />
          ) : (
            <Assignment fontSize="medium" style={{ color: mode === 'light' ? '#0485bf' : '#b5b5b5' }} />
          )}
        </button>
        {codeInfo?.time && (
          <span style={{ fontSize: '0.8rem', color: '#626262' }}>{`Submitted: ${new Date(
            codeInfo?.time,
          ).toLocaleString()}`}</span>
        )}
      </div>

      {/* 
       <Grid item sm md lg xs={12}>
            <Autocomplete
              style={{ width: 250, color: 'white' }}
              defaultValue={
                codeInfo && codeInfo.codeNumber !== '' && codeInfo.codeDescription !== ''
                  ? `${codeInfo?.codeNumber}:${codeInfo?.codeDescription}`
                  : null
              }
              id={id}
              className="disposition-autocomplete-container"
              options={codeTables[0]?.items?.map((code) => code.id)}
              freeSolo
              disableListWrap
              filterOptions={createFilterOptions({
                limit: 15,
              })}
              blurOnSelect
              disabled={
                state === 'RINGING'
                // || state === 'TALKING'
              }
              disablePortal={false}
              closeIcon={<Clear style={{ color: mode === 'light' ? 'black' : 'white' }} />}
              onChange={(e: any) => {
                const foundItem: CodeItem | undefined = codeTables[0].items?.find(
                  (item) => item.id?.trim() === e.target?.innerText?.trim(),
                );
                handleSetCustomDisposition(id, 'Disposition', foundItem);
              }}
              ListboxProps={{
                style: {
                  color: mode === 'light' ? 'black' : 'white',
                  background: mode === 'light' ? 'white' : '#444',
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  helperText={codeInfo?.time && <>{`Submitted: ${new Date(codeInfo?.time).toLocaleString()}`}</>}
                  size="small"
                  style={{ color: 'white' }}
                  fullWidth
                />
              )}
            />
          </Grid>
      */}
    </div>
  );
};

const CallRow = ({
  hasCx,
  currentCall,
  event,
  vip,
  callOnClick,
  codeTables,
  setCode,
  mode,
  codeTab,
}: {
  hasCx: boolean;
  currentCall: boolean;
  mode: string;
  vip: VipItem | undefined;
  event: DispositionEvent;
  callOnClick: (n: string) => void;
  codeTables: CodeTable[];
  setCode: (id: string, type: 'Disposition' | 'Account' | 'Forced', codeItem: CodeItem | undefined) => void;
  codeTab: 'Disposition' | 'Account' | 'Forced';
}) => {
  const {
    id,
    codeInfo,
    accountInfo,
    forcedInfo,
    userId,
    direction,
    date,
    duration,
    state,
    fromNumber,
    toNumber,
    internal,
    fromName,
    toName,
    rating,
  } = event;

  return (
    <div className={`disposition-call-row ${mode === 'light' ? 'disposition-light-mode' : 'disposition-dark-mode'}`}>
      <div className="disposition-call-row-left">
        <button
          disabled={currentCall}
          className={`disposition-dial-button ${currentCall && 'disabled'}`}
          type="button"
          onClick={() => callOnClick(direction === 'Inbound' ? fromNumber : toNumber)}
        >
          <div className="disposition-button-row">
            {direction === 'Inbound' && (
              <div
                className="disposition-button-content"
                style={{ color: currentCall ? colorGetter(state, mode) : mode === 'light' ? 'black' : 'white' }}
              >
                <div>
                  <DirectionRenderer direction={direction} mode={mode} />
                </div>
                <div className="content-right">
                  {!vip && <div className="content-right_header">{fromName}</div>}
                  {vip && (
                    <div className={`content-right_header ${mode === 'light' ? 'light-vip' : 'dark-vip'}`}>
                      <Star fontSize="small" style={{ color: mode === 'light' ? '#c8b343' : '#ccae0e' }} />
                      {vip.name}
                    </div>
                  )}
                  <div className="content-right_subheader">{fromNumber}</div>
                </div>
              </div>
            )}
            {direction !== 'Inbound' && (
              <div
                className="disposition-button-content"
                style={{ color: currentCall ? colorGetter(state, mode) : mode === 'light' ? 'black' : 'white' }}
              >
                <div>
                  <DirectionRenderer direction={direction} mode={mode} />
                </div>
                <div className="content-right">
                  {!vip && <div className="content-right_header">{toName}</div>}
                  {vip && (
                    <div className={`content-right_header ${mode === 'light' ? 'light-vip' : 'dark-vip'}`}>
                      <Star fontSize="small" style={{ color: mode === 'light' ? '#c8b343' : '#ccae0e' }} />
                      {vip.name}
                    </div>
                  )}
                  <div className="content-right_subheader">{toNumber}</div>
                </div>
              </div>
            )}
          </div>
        </button>
      </div>
      <div className="disposition-call-row-center">
        <div>
          {' '}
          {new Date(date).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </div>
        <div>
          {' '}
          <DurationRenderer state={state} time={duration} />
        </div>
      </div>
      <div className="disposition-call-row-right">
        {codeTab === 'Disposition' && (
          <Grid item sm md lg xs={12}>
            <Autocomplete
              style={{ width: 250, color: 'white' }}
              defaultValue={
                codeInfo && codeInfo.codeNumber !== '' && codeInfo.codeDescription !== ''
                  ? `${codeInfo?.codeNumber}:${codeInfo?.codeDescription}`
                  : null
              }
              id={id}
              className="disposition-autocomplete-container"
              options={codeTables[0]?.items?.map((code) => code.id)}
              freeSolo
              disableListWrap
              filterOptions={createFilterOptions()}
              blurOnSelect
              disabled={
                state === 'RINGING'
                // || state === 'TALKING'
              }
              disablePortal={false}
              closeIcon={<Clear style={{ color: mode === 'light' ? 'black' : 'white' }} />}
              onChange={(e: any) => {
                const foundItem: CodeItem | undefined = codeTables[0].items?.find(
                  (item) => item.id?.trim() === e.target?.innerText?.trim(),
                );
                setCode(id, 'Disposition', foundItem);
              }}
              ListboxProps={{
                style: {
                  color: mode === 'light' ? 'black' : 'white',
                  background: mode === 'light' ? 'white' : '#444',
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  helperText={codeInfo?.time && <>{`Submitted: ${new Date(codeInfo?.time).toLocaleString()}`}</>}
                  size="small"
                  style={{ color: 'white' }}
                  fullWidth
                />
              )}
            />
          </Grid>
        )}
        {codeTab === 'Account' && (
          <Autocomplete
            style={{ width: 250, color: 'white' }}
            defaultValue={
              accountInfo && accountInfo.codeNumber !== '' && accountInfo.codeDescription !== ''
                ? `${accountInfo?.codeNumber}:${accountInfo?.codeDescription}`
                : null
            }
            id={id}
            className="disposition-autocomplete-container"
            options={codeTables[1]?.items?.map((code) => code.id)}
            freeSolo
            filterOptions={createFilterOptions({
              limit: 15,
            })}
            blurOnSelect
            disabled={
              state === 'RINGING'
              //  || state === 'TALKING'
            }
            disablePortal
            closeIcon={<Clear style={{ color: mode === 'light' ? 'black' : 'white' }} />}
            onChange={(e: any) => {
              const foundItem: CodeItem | undefined = codeTables[1]?.items?.find(
                (item) => item?.id?.trim() === e.target?.innerText?.trim(),
              );
              setCode(id, 'Account', foundItem);
            }}
            ListboxProps={{
              style: {
                color: mode === 'light' ? 'black' : 'white',
                background: mode === 'light' ? 'white' : '#444',
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                helperText={accountInfo?.time && <>{`Submitted: ${new Date(accountInfo?.time).toLocaleString()}`}</>}
                size="small"
                style={{ color: 'white' }}
                fullWidth
              />
            )}
          />
        )}
        {codeTab === 'Forced' && (
          <Autocomplete
            style={{ width: 250, color: 'white' }}
            defaultValue={
              forcedInfo && forcedInfo.codeNumber !== '' && forcedInfo.codeDescription !== ''
                ? `${forcedInfo?.codeNumber}:${forcedInfo?.codeDescription}`
                : null
            }
            id={id}
            className="disposition-autocomplete-container"
            options={codeTables[2]?.items?.map((code) => code.id)}
            freeSolo
            filterOptions={createFilterOptions({
              limit: 15,
            })}
            blurOnSelect
            disabled={
              state === 'RINGING'
              //  || state === 'TALKING'
            }
            disablePortal
            closeIcon={<Clear style={{ color: mode === 'light' ? 'black' : 'white' }} />}
            onChange={(e: any) => {
              const foundItem: CodeItem | undefined = codeTables[2]?.items?.find(
                (item) => item?.id?.trim() === e.target?.innerText?.trim(),
              );
              setCode(id, 'Forced', foundItem);
            }}
            ListboxProps={{
              style: {
                color: mode === 'light' ? 'black' : 'white',
                background: mode === 'light' ? 'white' : '#444',
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                helperText={forcedInfo?.time && <>{`Submitted: ${new Date(forcedInfo?.time).toLocaleString()}`}</>}
                size="small"
                style={{ color: 'white' }}
                fullWidth
              />
            )}
          />
        )}
        {/* <div style={{display: 'flex' }}>
          <p>Agent Score</p>
          {[1, 2, 3, 4, 5].map((star) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <span
              key={star}
              style={{
                cursor: 'pointer',
                fontSize: 20,
                color: star <= (rating || 0) ? '#FFD700' : mode === 'light' ? '#ccc' : '#555',
                marginRight: 2,
                marginTop: 10,
                marginLeft: 2,
              }}
              onClick={() => {}}
            >
              ★
            </span>
          ))}
        </div> */}
        {/* {
        hasCx && (
          <span className={`ex-indicator ${mode}`}>EX</span> 
        )
      }    */}
      </div>
    </div>
  );
};

export default function NewDisposition({
  setCodeMap,
  dispositionCodes,
  accountCodes,
  forcedCodes,
  idToken,
  accessToken,
  vip,
  codeMap,
  noEncoding,
  organizationId,
  rcId,
  origin,
  hasAccountCodes,
  hasDispositionCodes,
  hasForcedCodes,
  mode,
  cxCallLog,
  hasCx,
}: {
  setCodeMap: React.Dispatch<React.SetStateAction<ImmutableMap<string, DispositionEvent>>>;
  dispositionCodes: CodeTable[];
  accountCodes: CodeTable[];
  forcedCodes: CodeTable[];
  idToken: string;
  accessToken: string;
  vip: VipItem[];
  codeMap: ImmutableMap<string, DispositionEvent>;
  noEncoding: boolean;
  organizationId: string;
  rcId: string;
  origin: string;
  mode: string;
  hasAccountCodes: boolean;
  hasDispositionCodes: boolean;
  hasForcedCodes: boolean;
  cxCallLog: CxCall[] | undefined;
  hasCx: boolean;
}) {
  const [dispositionCodeTable, setCodeTable] = useState<CodeTable>(dispositionCodes[0]);
  const [accountCodeTable, setAccountCodeTable] = useState<CodeTable>(accountCodes[0]);
  const [forcedCodeTable, setForcedCodeTable] = useState<CodeTable>(forcedCodes[0]);
  const [showInternal, setShowInternal] = useState(true);
  const [showMissed, setShowMissed] = useState(false);
  const [showCallType, setShowCallType] = useState<'All' | 'Outbound' | 'Inbound'>('All');
  const [textFilter, setTextFilter] = useState<string>('');
  const [codeTab, setCodeTab] = useState<'Disposition' | 'Account' | 'Forced'>('Disposition');
  const [currentCall, setCurrentCall] = useState<boolean>(false);
  const [cxCalls, setCxCalls] = useState<CxCall[] | undefined>(undefined);
  const [displayCXcalls, setDisplayCXcalls] = useState<boolean>(hasCx);
  const [displayEXcalls, setDisplayEXcalls] = useState<boolean>(true);

  useEffect(() => {
    if (rcId && origin) {
      if (hasDispositionCodes && !hasAccountCodes) {
        setCodeTab('Disposition');
      }
      if (!hasDispositionCodes && hasAccountCodes) {
        setCodeTab('Account');
      }
    }
  }, [hasDispositionCodes, hasAccountCodes, origin, rcId]);

  // useEffect(() => {
  //   if (hasCx) {
  //     setDisplayCXcalls(true);
  //   }
  // }, [hasCx, rcId]);

  // Load saved settings --> runs once on mount []
  useEffect(() => {
    const savedCX = localStorage.getItem('displayCXcalls');
    const savedEX = localStorage.getItem('displayEXcalls');

    if (savedCX !== null) {
      setDisplayCXcalls(JSON.parse(savedCX));
    }

    if (savedEX !== null) {
      setDisplayEXcalls(JSON.parse(savedEX));
    }
  }, []);

  // Save to localStorage
  const handleDisplayCXcalls = (value: boolean) => {
    setDisplayCXcalls(value);
    localStorage.setItem('displayCXcalls', JSON.stringify(value));
  };

  const handleDisplayEXcalls = (value: boolean) => {
    setDisplayEXcalls(value);
    localStorage.setItem('displayEXcalls', JSON.stringify(value));
  };

  useEffect(() => {
    setCurrentCall([...codeMap.values()].some((call) => call.state === 'RINGING' || call.state === 'TALKING'));
  }, [codeMap]);

  const callOnClick = useCallback(
    (phoneNumber: string) => {
      const dialerRef = document.querySelector('#ex-dialer') as HTMLIFrameElement;
      dialerRef.contentWindow!.postMessage(
        {
          type: 'rc-adapter-new-call',
          phoneNumber,
          toCall: true,
        },
        '*',
      );
    },
    [origin],
  );

  const setCode = useCallback(
    async (id: string, type: 'Disposition' | 'Account' | 'Forced', codeItem: CodeItem | undefined) => {
      let prefix;
      switch (type) {
        case 'Disposition':
          prefix = 'DPL';
          break;
        case 'Account':
          prefix = 'APL';
          break;
        case 'Forced':
          prefix = 'FPL';
          break;
        default:
          break;
      }

      const [codeNumber, codeDescription] = codeItem?.id?.split(':') || ['', ''];
      const codeCallId = id.split('-')[1];
      const message = `${prefix}:${codeCallId}:${codeNumber}:${codeDescription}`;
      const promises = [];

      promises.push(
        fetch(`${process.env.REACT_APP_API_URL}/flash`, {
          method: 'POST',
          body: JSON.stringify({
            type,
            message,
            id: rcId,
            token: accessToken,
          }),
          headers: {
            authorization: idToken,
          },
        }),
      );

      const eventTime = new Date().toISOString();
      const uuid = uuidv4();

      promises.push(
        await fetch(`${process.env.REACT_APP_API_URL}/disposition-codes`, {
          method: 'POST',
          body: JSON.stringify({
            prefix,
            codeCallId,
            codeNumber,
            codeDescription,
            accountId: organizationId,
            extensionId: rcId,
            telephonySessionId: id,
            time: eventTime,
            code: type,
            message,
            id: uuid,
            address: `${process.env.REACT_APP_API_URL}/site/main-site`,
          }),
          headers: {
            Authorization: idToken || '',
          },
        }),
      );
      const [flashRes, postRes] = await Promise.all(promises);

      if (postRes.ok && flashRes.ok) {
        setCodeMap((oldCodeMap) => {
          if (type === 'Disposition') {
            return oldCodeMap.update(id, (existing = {} as DispositionEvent) => ({
              ...existing,
              codeInfo: {
                code: type,
                codeDescription,
                codeNumber,
                time: eventTime,
              },
            }));
          }
          if (type === 'Account') {
            return oldCodeMap.update(id, (existing = {} as DispositionEvent) => ({
              ...existing,
              accountInfo: {
                code: type,
                codeDescription,
                codeNumber,
                time: eventTime,
              },
            }));
          }
          if (type === 'Forced') {
            return oldCodeMap.update(id, (existing = {} as DispositionEvent) => ({
              ...existing,
              forcedInfo: {
                code: type,
                codeDescription,
                codeNumber,
                time: eventTime,
              },
            }));
          }
          return oldCodeMap;
        });
      }
    },
    [accessToken, idToken, codeTab],
  );

  return (
    <div className="disposition-grid-container" style={{ background: mode === 'light' ? 'white' : '#333' }}>
      <div className="disposition-filter-row">
        <RadioGroup
          style={{ display: 'flex', flexDirection: 'row' }}
          name="Show-Call-Type"
          value={showCallType}
          onChange={(e: any) => setShowCallType(e.target.value)}
        >
          <FormControlLabel
            value="All"
            control={<Radio style={{ color: mode === 'light' ? '#0485bf' : 'white' }} />}
            label="All"
          />
          <FormControlLabel
            value="Outbound"
            control={<Radio style={{ color: mode === 'light' ? '#0485bf' : 'white' }} />}
            label="Outbound"
          />
          <FormControlLabel
            value="Inbound"
            control={<Radio style={{ color: mode === 'light' ? '#0485bf' : 'white' }} />}
            label="Inbound"
          />
        </RadioGroup>
        <div>
          <Checkbox
            style={{ color: mode === 'light' ? '#0485bf' : 'white' }}
            checked={showMissed}
            onClick={() => setShowMissed((prev) => !prev)}
          />
          Missed Calls
        </div>
        <div>
          <Checkbox
            style={{ color: mode === 'light' ? '#0485bf' : 'white' }}
            checked={showInternal}
            onClick={() => setShowInternal((prev) => !prev)}
          />
          Internal
        </div>
      </div>
      {hasCx && (
        <span style={{ display: 'flex' }}>
          <div>
            <Checkbox
              style={{ color: mode === 'light' ? '#0485bf' : 'white' }}
              checked={displayCXcalls}
              // onClick={() => setDisplayCXcalls((prev) => !prev)}
              // call function on inverse
              onClick={() => handleDisplayCXcalls(!displayCXcalls)}
            />
            CX calls
          </div>
          <div>
            <Checkbox
              style={{ color: mode === 'light' ? '#0485bf' : 'white' }}
              checked={displayEXcalls}
              // onClick={() => setDisplayEXcalls((prev) => !prev)}
              onClick={() => handleDisplayEXcalls(!displayEXcalls)}
            />
            EX calls
          </div>
        </span>
      )}
      <div className="disposition-filter-row text-row">
        <Search style={{ position: 'absolute', left: 10, top: 25, color: mode === 'light' ? '#aaa' : '#999' }} />
        <input
          style={{
            border: mode === 'light' ? '1px solid #aaa' : '1px solid #666',
            background: mode === 'light' ? 'white' : '#333',
            color: mode === 'light' ? 'black' : 'white',
          }}
          className="disposition-text-box-filter"
          onChange={(e) => setTextFilter(e.target.value)}
        />
      </div>
      <div className="disposition-filter-row tabs">
        {/* if user has both disposition and account codes, we'll display these buttons */}
        <>
          {hasDispositionCodes && (
            <button
              className={`${mode === 'light' ? 'light' : 'dark'} ${codeTab === 'Disposition' ? 'active' : ''}`}
              type="button"
              onClick={() => setCodeTab('Disposition')}
            >
              Disposition Codes
            </button>
          )}
          {hasAccountCodes && (
            <button
              className={`${mode === 'light' ? 'light' : 'dark'} ${codeTab === 'Account' ? 'active' : ''}`}
              type="button"
              onClick={() => setCodeTab('Account')}
            >
              Account Codes
            </button>
          )}

          {hasForcedCodes && (
            <button
              className={`${mode === 'light' ? 'light' : 'dark'} ${codeTab === 'Forced' ? 'active' : ''}`}
              type="button"
              onClick={() => setCodeTab('Forced')}
            >
              Forced Account Codes
            </button>
          )}
        </>
      </div>
      <div
        className={`disposition-call-row-container ${
          mode === 'light' ? 'disposition_light_mode' : 'disposition_dark_mode'
        }`}
      >
        {/* {
          cxCallLog && cxCallLog.map((cxCall) => (
            <div>
              {cxCall.timestamp}
            </div>
          ))
        } */}

        {[...codeMap.entries(), ...new Map(cxCallLog?.map((item) => [item.callId, item]))]
          .filter(([__, e]) =>
            `
        ${(e as DispositionEvent)?.fromName}
        ${(e as DispositionEvent)?.toName}
        ${(e as unknown as CxDispositionEvent)?.ani}
        ${(e as DispositionEvent)?.toNumber}`
              ?.toLowerCase()
              ?.includes(textFilter?.toLowerCase()),
          )
          .filter(([key, event]) => {
            if (showCallType === 'All') return true;
            return event.direction === showCallType;
          })
          .filter(([key, event]) => showInternal || !(event as DispositionEvent)?.internal)
          .filter(([key, event]) => {
            if (showMissed) return event;
            return event.state !== 'MISSED';
          })
          .filter(([key, event]) => {
            if (displayCXcalls) return event;
            return (event as unknown as CxDispositionEvent).extensionId === undefined;
          })
          .filter(([key, event]) => {
            if (displayEXcalls || !hasCx) return event;
            return (event as unknown as CxDispositionEvent).extensionId !== undefined;
          })
          .sort(
            ([k1, event1], [k2, event2]) =>
              new Date(
                (event2 as DispositionEvent).date ||
                  (event2 as unknown as CxDispositionEvent).timestamp.replace(/Z$/, ''),
              ).getTime() -
              new Date(
                (event1 as DispositionEvent).date ||
                  (event1 as unknown as CxDispositionEvent).timestamp.replace(/Z$/, ''),
              ).getTime(),
          )
          .map(([key, event]) => {
            const isMesserliKramer = organizationId === '62983216023';
            if (isMesserliKramer) {
              return (
                <MesserliKramerCallRow
                  key={key}
                  mode={mode}
                  organizationId={organizationId}
                  codeMap={codeMap}
                  rcId={rcId}
                  hasCx={hasCx}
                  setCodeMap={setCodeMap}
                  idToken={idToken}
                  // setSelectedCall={setSelectedCall}
                  event={event as DispositionEvent}
                  codeTab={codeTab}
                  callOnClick={callOnClick}
                  codeTables={[dispositionCodeTable, accountCodeTable, forcedCodeTable]}
                  setCode={setCode}
                  currentCall={currentCall}
                  vip={vip?.find((number) => {
                    if ((event as DispositionEvent).direction === 'Inbound') {
                      if (regexCheck((event as DispositionEvent).fromNumber, number.number)) {
                        return number;
                      }
                      return undefined;
                    }
                    if (event.direction !== 'Inbound') {
                      if (regexCheck((event as DispositionEvent).toNumber, number.number)) {
                        return number;
                      }
                      return undefined;
                    }
                    return undefined;
                  })}
                />
              );
            } else {
              if ((event as unknown as CxDispositionEvent).extensionId) {
                return (
                  <CxCallRow
                    currentCall={currentCall}
                    callOnClick={callOnClick}
                    mode={mode}
                    event={event as unknown as CxDispositionEvent}
                    vip={vip?.find((number) => {
                      if ((event as unknown as CxDispositionEvent).direction === 'Inbound') {
                        if (regexCheck((event as unknown as CxDispositionEvent).ani, number.number)) {
                          return number;
                        }
                        return undefined;
                      }
                      if (event.direction !== 'Inbound') {
                        if (regexCheck((event as unknown as CxDispositionEvent).ani, number.number)) {
                          return number;
                        }
                        return undefined;
                      }
                      return undefined;
                    })}
                  />
                );
              }
              return (
                <CallRow
                  key={key}
                  mode={mode}
                  hasCx={hasCx}
                  event={event as DispositionEvent}
                  codeTab={codeTab}
                  callOnClick={callOnClick}
                  codeTables={[dispositionCodeTable, accountCodeTable, forcedCodeTable]}
                  setCode={setCode}
                  currentCall={currentCall}
                  vip={vip?.find((number) => {
                    if ((event as DispositionEvent).direction === 'Inbound') {
                      if (regexCheck((event as DispositionEvent).fromNumber, number.number)) {
                        return number;
                      }
                      return undefined;
                    }
                    if (event.direction !== 'Inbound') {
                      if (regexCheck((event as DispositionEvent).toNumber, number.number)) {
                        return number;
                      }
                      return undefined;
                    }
                    return undefined;
                  })}
                />
              );
            }
          })}
      </div>
    </div>
  );
}
